/**
 * UUID v4 — randomUUID() csak secure contextben (HTTPS / localhost) garantált.
 * http://chatbot.test (Herd) esetén getRandomValues fallback kell.
 */
export function generateUuid() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return crypto.randomUUID();
    }

    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        bytes[6] = (bytes[6] & 0x0f) | 0x40;
        bytes[8] = (bytes[8] & 0x3f) | 0x80;

        const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');

        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === 'x' ? r : (r & 0x3) | 0x8;

        return v.toString(16);
    });
}

export function conversationStorageKey(botKey) {
    return `chatbot_conv_${botKey}`;
}

export function getStoredConversationId(botKey) {
    try {
        return localStorage.getItem(conversationStorageKey(botKey));
    } catch {
        return null;
    }
}

export function setStoredConversationId(botKey, conversationId) {
    try {
        localStorage.setItem(conversationStorageKey(botKey), conversationId);
    } catch {
        // ignore private mode
    }
}

export function clearStoredConversationId(botKey) {
    try {
        localStorage.removeItem(conversationStorageKey(botKey));
    } catch {
        // ignore private mode
    }
}

/*
 * session_id + conversation_id együtt azonosítja a thread-et (resolveForWidget).
 * Tab/reload: stored conversation_id + history → folytatás (kosár megmarad).
 * Új beszélgetés / üres history: mindkettő törlődik → szerveren tényleg új conversation.
 */
const SESSION_STORAGE_KEY = 'chatbot_widget_session';

export function getOrCreateSessionId() {
    try {
        let id = localStorage.getItem(SESSION_STORAGE_KEY);

        if (! id) {
            id = generateUuid();
            localStorage.setItem(SESSION_STORAGE_KEY, id);
        }

        return id;
    } catch {
        return generateUuid();
    }
}

/** Új beszélgetés: új session_id, hogy a szerver ne a régi thread-et adja vissza. */
export function resetWidgetSession() {
    try {
        localStorage.setItem(SESSION_STORAGE_KEY, generateUuid());
    } catch {
        // ignore private mode
    }
}
